import React from 'react';
import { connect } from 'react-redux';
import { formatDate } from '../../../../utils/helper';
// import CheckCircleOutlineOutlined from '../../../../../static/assets/svg/mui-icons/CheckCircleOutlineOutlined.svg';
// import SwapHorizontalCircleOutlined from '../../../../../static/assets/svg/mui-icons/SwapHorizontalCircleOutlined.svg';
import ReturnProductDetails from './ReturnProductDetails';
import PaymentSummery from './PaymentSummery';
const packageTypes = [
  'zero_power',
  'single_vision',
  'bifocal',
  'tinted_sv',
  'contact_lens',
  'sunglasses',
];

import './ReturnProductCard.scss';

function ReturnProductCard(props) {
  const {
    item,
    selectedReasonComponent,
    retunConfirmPage,
    returnItemId,
    refundMethodRequest,
    exchangeItem,
    cartData,
    children,
    dataLocale,
    hidePrice,
    hideProductId,
    returnEligibiliyDetails,
    dataLocale: { PRODUCT_IMG, SYMBOL_PLUS, CURRENCY_SYMBOL },
  } = props;
  const {
    options = [],
    productId,
    brandName,
    thumbnail,
    amount,
    productTypeValue,
    modelName,
    contactDisposableType,
    frameColour,
    frameShape,
    frameType,
  } = item || {};
  const {
    ELIGIBLE_FOR_EXCHANGE_RETURN_TILL,
    PRODUCT_TO_RETURN_EXCHANGE,
    PRODUCT_TO_EXCHANGE,
    FREE,
    NO_PRICE_DIFFERENCE,
  } = dataLocale;
  const currentItemreturnEligibility =
    returnEligibiliyDetails &&
    returnItemId &&
    returnEligibiliyDetails.items &&
    returnEligibiliyDetails.items.find(
      item => parseInt(item.id, 10) === parseInt(returnItemId, 10)
    );
  const returnEligibleTillDate =
    currentItemreturnEligibility && currentItemreturnEligibility.returnEligibleTillDate;
  const exchangedProduct = retunConfirmPage
    ? exchangeItem && exchangeItem[0]
    : cartData && cartData?.items?.[0];
  const isNonZeroPayment = retunConfirmPage
    ? exchangeItem && exchangeItem[0].amount && exchangeItem[0].amount.total > 0
    : cartData && cartData.totals && cartData?.totals?.total > 0;
  let lensPackage;
  let coating;
  let type;
  let returnAllowedDate = '';
  const returnAllowedDateTs = returnEligibleTillDate && new Date(returnEligibleTillDate).getTime();
  returnAllowedDate = returnEligibleTillDate && formatDate(returnAllowedDateTs, 'D MMM', 'year');
  for (let i = 0, len = options.length; i < len; i++) {
    type = options[i].type && options[i].type.toLowerCase();
    if (packageTypes.includes(type)) {
      lensPackage = options[i].name;
    } else if (type === 'coating') {
      coating = options[i].name;
    }
  }
  let price = 0;
  if (amount) {
    const { total, discounts } = amount;
    const paidPrice = discounts.reduce((totalPrice, discount) => {
      if (['sc', 'exchange'].includes(discount.type)) {
        totalPrice += discount.amount;
        return totalPrice;
      }
      return null;
    }, 0);
    price = total + paidPrice;
  }
  return (
    <div>
      {selectedReasonComponent ? (
        <>
          <div className="display-flex margin-l20">
            <img alt={PRODUCT_IMG} src={thumbnail} width="50%" />
            <div className="margin-r5">
              {brandName && (
                <div className="margin-t4 margin-l45 margin-b7 fs16 fw500">{brandName}</div>
              )}
              {lensPackage && (
                <div key="lens-package" className="fs12 text-color-grey margin-l45">
                  {SYMBOL_PLUS} {lensPackage}
                </div>
              )}
              {!hidePrice && (
                <span className="margin-t5 fs14 text-color-grey">
                  {CURRENCY_SYMBOL} {(price && Math.round(price)) || 0}
                </span>
              )}
            </div>
          </div>
          <div className="margin-t15 text-left fs14 margin-l30 text-color-grey">
            {ELIGIBLE_FOR_EXCHANGE_RETURN_TILL} {returnAllowedDate}
          </div>
        </>
      ) : (
        <div className="align-items-center">
          {!exchangedProduct && (
            <>
              <div className="text-center margin-l12">
                <h4 className="fs20 text-left">
                  {refundMethodRequest !== null ? 'Product Returned' : PRODUCT_TO_RETURN_EXCHANGE}
                </h4>
              </div>
              <div className="margin-l12">
                <div className="margin-l12 margin-t12 display-flex">
                  <div>
                    <img alt={PRODUCT_IMG} className="margin-t15" src={thumbnail} width="70%" />
                  </div>
                </div>
                <div className={`fsp15 inline-block mr-b5${hidePrice ? '' : ' w70'}`}>
                  {productId && !hideProductId && (
                    <div className="fs12 text-color-grey">{productId}</div>
                  )}
                  {brandName && <div className="margin-t4 fs16 fw500 margin-b7">{brandName}</div>}
                </div>
                {frameColour && frameShape && (
                  <div className="fs12 text-color-grey">
                    {frameColour} {frameShape}
                    {frameType && (
                      <span className="text-capitalize"> {frameType.replace('_', ' ')}</span>
                    )}
                  </div>
                )}
                {lensPackage && (
                  <div key="lens-package" className="fs12 text-color-grey">
                    {SYMBOL_PLUS} {lensPackage}
                  </div>
                )}
                {coating && (
                  <div key="coating" className="fs12 text-color-grey">
                    + {coating}
                  </div>
                )}
                {productTypeValue !== 'Eyeglasses' &&
                  productTypeValue !== 'Sunglasses' &&
                  modelName && <div className="fs12 text-color-grey">{modelName}</div>}
                {productTypeValue === 'Contact Lens' && contactDisposableType && (
                  <div className="fs12 text-color-grey">{contactDisposableType}</div>
                )}
                {children || ''}
                {!hidePrice && (
                  <div className="fs14 tfw500 margin-t10">
                    {CURRENCY_SYMBOL} {(price && Math.round(price)) || 0}
                  </div>
                )}
              </div>
            </>
          )}
          {exchangedProduct && (
            <>
              <div className="text-center margin-l12">
                <h4 className="fs20 text-left">{PRODUCT_TO_EXCHANGE}</h4>
              </div>
              {!isNonZeroPayment && (
                <div
                  style={{
                    textAlign: 'left',
                    backgroundColor: 'rgb(212 234 213)',
                    padding: '2px',
                    paddingLeft: '12px',
                  }}
                >
                  <div className="display-flex align-items-center">
                    <img
                      alt="check circle"
                      src="https://static.lenskart.com/media/desktop/img/myorder/CheckCircleOutlineOutlined.svg"
                      style={{ color: 'green', fontSize: 'x-large' }}
                    />
                    <h4 className="margin-l8 text-uppercase">{FREE}</h4>
                  </div>
                  <p className="margin-l31">{NO_PRICE_DIFFERENCE}</p>
                </div>
              )}
              <div
                className="margin-l12 padding-10 margin-r12 border border-radius10 lk-return-exchange"
                style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between' }}
              >
                <div className="margin-r10 lk-padding">
                  <ReturnProductDetails
                    dataLocale={dataLocale}
                    item={item}
                    returnedProductPrice={price}
                  />
                </div>
                <div className="divider"></div>
                <div className="swapCircleWrapper">
                  <img
                    alt="swap-circle"
                    className="swapCircle"
                    src="https://static.lenskart.com/media/desktop/img/myorder/SwapHorizontalCircleOutlined.svg"
                    style={{ fontSize: 'x-large' }}
                  />
                </div>
                <div className="lk-padding">
                  <ReturnProductDetails
                    exchangewith
                    dataLocale={dataLocale}
                    item={exchangedProduct}
                    returnedProductPrice={price}
                  />
                </div>
              </div>
              {isNonZeroPayment && (
                <div className="pd-b55 mr-t10 margin-l12 margin-r12">
                  <PaymentSummery
                    exchange
                    data={exchangedProduct}
                    dataLocale={dataLocale}
                    retunConfirmPage={retunConfirmPage}
                    totals={exchangedProduct?.amount}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    cartData,
    dataLocale: state.locale,
    paymentMethods: state.checkout.paymentMethods,
  };
};

export default connect(mapStateToProps, null)(ReturnProductCard);
